module.exports = __webpack_public_path__ + "media/images/lb/972-78c30b2467e01084775af7abf7e9646c.svg";